import * as Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import { formatNumber, formatUSDM, formatWAX } from '../helpers/FormatLinks'
import { useTheme } from 'next-themes'
function CollectionGraph(props) {
    const { theme } = useTheme()
    const [volume, setVolume] = useState(null)
    const chartRange = props.chartRange
    const volumeType = props.volumeType
    const currency = props.currency
    const collection = props.collection

    const parseVolume = (result) => {
        setVolume(result)
    }

    const getCollectionVolume = async () => {
        get(
            `collection-volume-graph/${chartRange}?type=${volumeType}${
                collection && collection !== '*'
                    ? '&collection=' + collection
                    : ''
            }`,
            'v3',
        ).then(parseVolume)
    }

    useEffect(() => {
        getCollectionVolume()
    }, [chartRange, volumeType])

    const colors = ['rgba(255, 255, 255, 0.8)', 'rgba(255, 255, 255, 0.1)']

    const series = []

    if (volume) {
        const len = Object.keys(volume).length
        for (let i = 0; i < len; i++) {
            const r =
                127.0 * ((len - i) / len) + 255.0 * (1.0 - (len - i) / len)
            const g = 228.0 * ((len - i) / len) + 64.0 * (1.0 - (len - i) / len)
            const b =
                153.0 * ((len - i) / len) + 138.0 * (1.0 - (len - i) / len)
            colors.push(
                `rgba(${parseInt(r)}, ${parseInt(g)}, ${parseInt(b)}, 100)`,
            )
        }
    }

    volume &&
        Object.keys(volume).map((object, index) => {
            series.push({
                borderWidth: 0,
                name: volume[object]['name'],
                color: colors[index % colors.length],
                data: volume[object]['graph'].map((item) => [
                    item['date'],
                    item[currency === 'wax' ? 'waxVolume' : 'usdVolume']
                        ? item[currency === 'wax' ? 'waxVolume' : 'usdVolume']
                        : 0,
                ]),
                tooltip: {
                    valueSuffix: currency === 'wax' ? ' WAX' : '',
                    valuePrefix: currency === 'wax' ? '' : '$',
                    fontSize: 10,
                },
                yAxis: 0,
                marker: {
                    enabled: false,
                },
            })
        })

    const chartOptions = volume
        ? {
              title: {
                  text: '',
              },
              chart: {
                  type: 'spline',
                  renderTo: 'Chart',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  margin: [60, 60, 120, 60],
              },
              plotOptions: {
                  spline: {
                      marker: {
                          enabled: false,
                      },
                  },
              },
              yAxis: [
                  {
                      offset: 0,
                      maxPadding: 0,
                      title: {
                          offset: 0,
                          style: {
                              color: theme === 'light' ? '#000000' : '#FEFEFE',
                              'font-family': 'sans',
                              'font-size': '12pt',
                          },
                          rotation: 0,
                          y: -20,
                          align: 'high',
                          text: 'Volume',
                      },
                      labels: {
                          style: {
                              color: theme === 'light' ? '#000000' : '#FEFEFE',
                              'font-family': 'sans',
                              'font-size': '10px',
                          },
                          formatter: function () {
                              return (
                                  (currency === 'usd' ? '$' : '') +
                                  formatNumber(this.value) +
                                  (currency === 'wax' ? ' WAX' : '')
                              )
                          },
                      },
                      showFirstLabel: false,
                  },
              ],
              xAxis: {
                  categories: volume[Object.keys(volume)[0]]['graph'].map(
                      (item) => item['date'],
                  ),
                  labels: {
                      style: {
                          color: theme === 'light' ? '#000000' : '#FEFEFE',
                          'font-family': 'sans',
                          'font-size': '10px',
                      },
                      align: 'center',
                      step: chartRange / 3,
                  },
              },
              tooltip: {
                  shared: true,
                  backgroundColor:
                      theme === 'light' ? '#FEFEFE' : 'rgba(0, 0, 0, 0.5)',
                  style: {
                      color: theme === 'light' ? '#000000' : '#FEFEFE',
                      'font-family': 'sans',
                      'font-size': '10px',
                  },
                  formatter: function () {
                      return this.points
                          .sort(function (a, b) {
                              if (a.point.y > b.point.y) {
                                  return -1
                              } else return 1
                          })
                          .reduce(function (s, point) {
                              return (
                                  s +
                                  '<br/>' +
                                  point.series.name +
                                  ': ' +
                                  (currency === 'wax'
                                      ? formatWAX(point.y)
                                      : formatUSDM(point.y))
                              )
                          }, '<b>' + this.x + '</b>')
                  },
              },

              series: series,
              legend: {
                  navigation: {
                      activeColor: '#3E576F',
                      animation: true,
                      arrowSize: 5,
                      inactiveColor: '#CCC',
                      style: {
                          fontWeight: 'bold',
                          color: '#333',
                          fontSize: '12px',
                      },
                  },
                  height: 100,
                  overflowY: 'auto',
                  itemStyle: {
                      color: theme === 'light' ? '#000000' : '#FEFEFE',
                      overflowY: 'auto',
                      maxHeight: 100,
                  },
              },
              credits: {
                  enabled: false,
              },
          }
        : null

    return (
        <div>
            {chartOptions !== null && (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                />
            )}
        </div>
    )
}

export default CollectionGraph
